import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { safeLocalStorage } from '~/store/safeLocalStorage'

interface DenominationState {
  isUsdMode: boolean
  setIsUsdMode: (value: boolean) => void
  toggle: () => void
}

export const useDenominationStore = create<DenominationState>()(
  persist(
    (set, get) => ({
      isUsdMode: true,
      setIsUsdMode: (value) => set({ isUsdMode: value }),
      toggle: () => set({ isUsdMode: !get().isUsdMode }),
    }),
    {
      name: 'denomination-mode',
      storage: safeLocalStorage,
      version: 1,
    },
  ),
)
